import React, { useState } from 'react';
import { Progress, Tag, Tooltip, Drawer, Button, Space, Input } from 'antd';
import CreativesApprovalsHolder from './CreativesApprovalsHolder';
import './CreatorCardComponent.styles.scss';
import { Link, useParams } from 'react-router-dom';
import { AddPostUrlToCampaign } from '../../../../apis/Admin/Campaigns/AddPostUrl';
import { useGlobalState } from '../../../../store/state';

const CreatorCardComponent = ({ influencer, creativesId, creativesCount, numbersOfPosts, resetAllCards }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [showAddUrl, setShowAddUrl] = useState(false);
  const [postUrl, updatePostUrl] = useState('');
  const [user] = useGlobalState('user');
  const params = useParams();
  const showDefaultDrawer = () => {
    setShowDrawer(true);
  };
  const showLargeDrawer = () => {
    setShowDrawer(true);
  };
  const onClose = () => {
    setShowAddUrl(false);
    setShowDrawer(false);
    // resetAllCards() // will re-refetch all cards after close
  };
  const addPostUrl = async () => {
    if (postUrl) {
      console.log({ campaignId: params.campaignId, influencerId: influencer._id, postUrl: postUrl });
      await AddPostUrlToCampaign({ token: user.accessToken, data: { campaignId: params.campaignId, influencerId: influencer._id, postUrl: postUrl } });
      updatePostUrl('');
      setShowAddUrl(false);
    }
  };

  const progressPercent = () =>{
    const { accepted, rejected, total } = numbersOfPosts;

    return (accepted + rejected) / total * 100;
  };
  return (
    <div className="col-md-4 px-2 my-2">
      <div className="common_card creator_card p-3 h-100">
        <div className="creator_card_top">
          <div className="creator_card_top_profs">
            <div className="creator_card_top_profs--avatar">
              <img src={influencer.picture}
                alt={influencer.firstname} />
            </div>
            <div className="creator_card_top_profs_text">
              <h4 title={influencer.firstname}>{influencer.firstname} {influencer.lastname}</h4>
              <p title={influencer._id}>{influencer._id}</p>
            </div>
          </div>
          <div className="creator_card_top_badge pt-1">
            {
              numbersOfPosts.total === numbersOfPosts.accepted ?
                <Tag color="green"
                  className="mr-0">Approved</Tag> :
                <Tag color="red"
                  className="mr-0">In Review</Tag>
            }
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="creator_card_middle">
          <ul>
            <li>
              <p>Total Creatives</p>
              <h6>{creativesCount}</h6>
            </li>
            <li>
              <p>Total Posts</p>
              <h6>{numbersOfPosts.total}</h6>
            </li>
          </ul>
        </div>
        <div className="creator_card_progess">
          <div className="d-flex justify-content-between">
            <div className="creator_card_progess--state">{numbersOfPosts.accepted}/{numbersOfPosts.total} Posts Approved</div>
            <div className="creator_card_progess--state">{numbersOfPosts.rejected} Rejected</div>
          </div>
          <Tooltip title="3 Accepted | 2 Rejected | 1 in review">
            <Progress percent={progressPercent()}
              strokeColor="#ff0000"
              success={{ percent: (numbersOfPosts.accepted / numbersOfPosts.total * 100) }}
              trailColor="#c9c9c9"/>
          </Tooltip>
        </div>
        <hr />
        <div className="text-right py-2">
          <Button onClick={showLargeDrawer}
            className="common_button outlined">View</Button>
          {/* drawer for view creatives */}
          <Drawer
            title={<>Submitted Creatives by <strong>{influencer.firstname} {influencer.lastname}</strong></>}
            placement="right"
            width={700}

            onClose={onClose}
            visible={showDrawer}
            extra={
              <Space>
                <Button onClick={onClose}>Cancel</Button>
                <Button type="primary"
                  onClick={onClose}>
                                OK
                </Button>
              </Space>
            }
          >
            <button className="common_button outlined"
              onClick={()=> setShowAddUrl(true)}>Add New Post URL</button>
            { showAddUrl &&
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 100, margin: '20px 0' }}>
                              <Input className="common_input "
                                size="large"
                                allowClear
                                value={postUrl}
                                onChange={(e) => updatePostUrl(e.target.value)}
                                placeholder="https://posturl.com"/>
                              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
                                <button className='common_button outlined'
                                  onClick={()=> setShowAddUrl(false)}>Cancel</button>
                                <button className='common_button'
                                  onClick={addPostUrl}>Add</button>
                              </div>
                            </div>
            }
            {/* <h1>Creatives need to come Here</h1> */}
            <CreativesApprovalsHolder influId={influencer._id}
              resetAllCards={resetAllCards}/>
          </Drawer>
        </div>
      </div>
    </div>
  );
};

export default CreatorCardComponent;
